export default "__VITE_ASSET__CfcPynCv__"